import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";

// Redux Store
const store = configureStore({ reducer: {}, devTools: true });

// 👉 Load Lordicon script globally (only once)
const script = document.createElement("script");
script.src = "https://cdn.lordicon.com/lordicon.js";
script.async = true;
document.body.appendChild(script);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// Performance reporting
reportWebVitals();
